import { JsToClientInterface } from '../jsToClientInterface';
import consoleLogger from '../../logger/consoleLogger';
import { JsToClientCommand } from '../jsToClientCommand';
import { EmscriptenClient } from './emscriptenClient';

const logger = consoleLogger.getPrefixedCopy('JS_TO_EMSCRIPTEN');

export class EmscriptenJsInterface implements JsToClientInterface {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public sendCommand<T>(command: JsToClientCommand<any>): T {
        logger.debug(`sendCommand ${command.getName()}`);
        EmscriptenClient.sendCommand(command.getName(), command.getParams() as object);
        return null as unknown as T;
    }

    public openAccountWindow(): void {
        EmscriptenClient.sendCommand('openAccountWindow', {});
    }
}
